<template>
  <div
    v-motion-pop
    class="superagent-launcher select-none"
    :class="[
      isOpen && 'opened',
      isOpen && isMobile && 'hidden',
      backgroundClass,
      'transition-colors',
    ]"
    @click.prevent="isOpen ? $emit('close') : $emit('open')"
  >
    <!--    <div v-if="newMessagesCount > 0 && !isOpen" class="superagent-new-messsages-count">-->
    <!--      {{ newMessagesCount }}-->
    <!--    </div>-->
    <XIcon
      v-if="isOpen"
      class="p-3 superagent-closed-icon text-current"
      :src="icons.close.img"
      :alt="icons.close.name"
    />
    <ChatIcon
      v-else
      class="superagent-open-icon text-current"
      :src="icons.open.img"
      :alt="icons.open.name"
    />
  </div>
</template>

<script>
import { computed, defineComponent } from "vue";
import CloseIcon from "@/assets/close-icon.png";
import OpenIcon from "@/assets/logo-no-bg.svg";
import { useApp } from "@/composables/use-app";
import { useWidgetTheme } from "@/composables/widgetTheme";
import { css } from "@emotion/css";
import { ChatIcon, XIcon } from "@heroicons/vue/outline";

const icons = {
  open: {
    img: OpenIcon,
    name: "Open chat",
  },
  close: {
    img: CloseIcon,
    name: "Close chat",
  },
};

export default defineComponent({
  name: "ChatLauncher",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    XIcon,
    ChatIcon,
  },
  emits: ["open", "close"],
  setup() {
    const { useMobileLayout } = useApp();
    const { theme } = useWidgetTheme();

    const backgroundClass = computed(
      () => css`
        background-color: ${theme.value?.launcherBackgroundColor};
        color: ${theme.value?.launcherIconColor};
      `
    );

    return {
      icons,
      isMobile: useMobileLayout,
      backgroundClass,
    };
  },
});
</script>

<style scoped lang="scss">
@import "@/assets/animation.scss";

.superagent-launcher {
  width: 60px;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  position: fixed;
  right: 25px;
  bottom: 25px;
  border-radius: 50%;
  box-shadow: none;
  transition: box-shadow 0.4s ease-in-out;
  cursor: pointer;
}

.superagent-launcher:before {
  content: "";
  position: relative;
  display: block;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  transition: box-shadow 0.4s ease-in-out;
}

.superagent-launcher .superagent-open-icon,
.superagent-launcher .superagent-closed-icon {
  width: 60px;
  height: 60px;
  position: fixed;
  right: 0;
  bottom: 0;
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
}

.superagent-launcher .superagent-closed-icon {
  transition: opacity 100ms ease-in-out, transform 100ms ease-in-out;
  width: 60px;
  height: 60px;
}

.superagent-launcher .superagent-open-icon {
  padding: 16px;
  box-sizing: border-box;
  opacity: 1;
  @include animation(0, 0.75s, fade-in);
}

.superagent-launcher.opened .superagent-open-icon {
  transform: rotate(-90deg);
  opacity: 1;
}

.superagent-launcher.opened .superagent-closed-icon {
  transform: rotate(-90deg);
  opacity: 1;
  @include animation(0, 0.5s, rotation-lr);
}

//.superagent-launcher.opened:before {
//  box-shadow: 0px 0px 400px 250px rgba(148, 149, 150, 0.2);
//}

.superagent-launcher:hover {
  box-shadow: 0 0px 27px 1.5px rgba(0, 0, 0, 0.2);
}

.superagent-new-messsages-count {
  position: absolute;
  top: -3px;
  left: 41px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  border-radius: 50%;
  width: 22px;
  height: 22px;
  background: #ff4646;
  color: white;
  text-align: center;
  margin: auto;
  font-size: 12px;
  font-weight: 500;
}
</style>
